import { ADD_HISTORY, GET_HISTORY,UPDATE_READ} from '../types'

const INITIAL_STATE = {
  allHistory: [],
  addedHistory: [],
  readhistory:[],
  unreadCount:null
}
const historyReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_HISTORY:
      return {
        ...state,
        allHistory: payload.data?.data,
        unreadCount:payload.unreadCount
      }
    case ADD_HISTORY:
      return {
        ...state,
        addedHistory: payload.data,
      }
      case UPDATE_READ:
        return {
          ...state,
          readhistory: payload.data,
        }
    default:
      return state
      
  }
}

export default historyReducer
